function Footer() {
  return <footer>Copyright &copy; 2021 Dev/Mission</footer>;
}

export default Footer;
